import { observer } from "mobx-react-lite";
import { FunctionComponent } from "../../components/FunctionComponent/FunctionComponent";
import i from "../../translations/i";
import { Button, Space } from "antd";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import React from "react";
import { useParams } from "react-router-dom";
import { ParamTypes } from "../../helpers/types.interfaces";

export const DefaultPictures = observer(() => {

  return <FunctionComponent
    options={{
      title: i.t('defaultPictures:title'),
      buttons: [
        { title: i.t('def:actions.create'), href: `/settings/default_pictures/0`, type: 'primary', plan: 1 }
      ],
      items: [
        {
          type: 'table',
          columns: [
            { title: 'ID', dataIndex: 'id', key: 'id' },
            { title: i.t('settings:project.name'),  dataIndex: ['element', 'label'], key: 'label' }
          ],
          actions: {
            edit: {
              redirect: `/settings/default_pictures`,
              isId: true,
            },
            delete: {
              formAction: {
                path: '/default_pictures',
                isId: true,
                method: 'delete',
                result: {
                  redirect: '/settings/default_pictures'
                }
              },
            }
          },
          requestData: {
            method: 'get',
            path: '/default_pictures',
            entity: 'lists'
          }
        }
      ]
    }}
  />
})

export const DefaultPicture = observer(() => {

  const { id }: any = useParams<ParamTypes>()

  return <FunctionComponent
    options={{
      title: i.t('defaultPictures:systemImage'),
      buttons: [
        { title: i.t('def:actions.backList'), href: `/settings/default_pictures`, type: 'dashed' },
        { title: i.t('def:actions.save'), htmlType: `submit`, type: 'primary' }
      ],
      model: {
        id: null,
        default_id: null,
        file: null
      },
      formAction: {
        path: '/default_pictures',
        isId: true,
        method: 'post',
        result: {
          redirect: '/settings/default_pictures'
        }
      },
      items: [
        {
          type: 'form',
          requestData: (id && id > 0) ? {
            method: 'get',
            path: `/default_pictures/${id}`,
            isId: true,
            entity: 'model'
          } : null,
          fields: [
            {
              type: 'select',
              name: 'default_id',
              span: 12,
              label: i.t('defaultPictures:selectImageType'),
              requestData: {
                method: 'get',
                path: '/default_pictures/default',
                entity: 'lists'
              },
              dataLabels: {
                label: 'label',
                id: 'id'
              }
            },
            {
              type: 'file',
              name: 'image',
              span: 24,
              label: i.t('def:image.image')
            },
          ],
        },
      ]
    }}
    form={true}
  />
})